import React from "react";
import { BasicTable } from "../types";
import { UserIcon } from "@heroicons/react/24/solid";
import { FaChair } from "react-icons/fa";

type Props = {
  table: BasicTable;
  onOpen: (table: BasicTable) => void;
};

const TableCard: React.FC<Props> = ({ table, onOpen }) => {
  const { isAvailable, tableLabel, seatCapacity } = table;

  return (
    <div className="w-full @container">
      <div
        onClick={() => onOpen(table)}
        className={`
          relative aspect-square w-full flex flex-col items-center justify-between
          p-[8cqw] rounded-[15cqw] border-2 transition-all duration-300
          cursor-pointer select-none overflow-hidden
          ${isAvailable
            ? "bg-[#1e293b] border-slate-700 hover:border-emerald-500/50"
            : "bg-[#1e293b] border-orange-500 shadow-[inset_0_0_15px_rgba(249,115,22,0.2)]"}
          active:scale-95 group
        `}
      >
        {/* Status Dot: Sized using Container Query Width (cqw) */}
        <div className={`absolute top-[8cqw] right-[8cqw] h-[8cqw] w-[8cqw] max-h-3 max-w-3 rounded-full
          ${isAvailable ? "bg-emerald-500" : "bg-orange-500 animate-pulse"}`}
        />

        {/* 1. Main Label: Fluid Typography via cqw */}
        <div className="flex-1 flex flex-col items-center justify-center w-full min-h-0">
          <h3
            className={`
            w-full text-center font-bold leading-none
            text-[clamp(8px,14cqw,1.4rem)]
            break-words
            ${isAvailable ? "text-slate-100" : "text-orange-400"}
          `}
          >
            {tableLabel || "Table"}
          </h3>

          {/* 2. Capacity: Resizes and hides if too cramped */}
          <div className="flex items-center mt-[2cqw] text-slate-400 @[120px]:flex hidden">
            {seatCapacity && (
              <div className="flex items-center gap-[1cqw]">
                <FaChair className="text-[10cqw]" />
                <span className="text-[11cqw] font-medium">{seatCapacity}</span>
              </div>
            )}
          </div>
        </div>

        {/* 3. Footer: Text and Icons scale together */}
        <div className="w-full flex flex-col items-center mt-auto">
          {!isAvailable && (
            <UserIcon className="w-[12cqw] h-[12cqw] text-orange-500 mb-[1cqw]" />
          )}

          <p className={`
            text-[6cqw] font-black uppercase tracking-widest text-center
            ${isAvailable ? "text-slate-500" : "text-orange-500"}
          `}>
            {isAvailable ? "Start" : "Modify"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TableCard;